import React from 'react'
import styles from './WarningLine.module.scss'
import { Icon } from 'components/common'
import { icons } from 'assets'
import { Props } from './types'
import { getWarningText } from './utils'

const WarningLine = (props: Props) => {
  const text = getWarningText(props)

  return (
    <div className={styles.lineContainer}>
      <Icon
        icon={icons.exclamationMark}
        className={styles.warningIcon}
      />
      <div className={styles.textContainer}>
        <p>{text.title}</p>
        <p dangerouslySetInnerHTML={{ __html: text.subtitle }} />
      </div>
    </div>
  )
}

export default WarningLine
